// Section names with translations
export const SECTION_NAMES = {
  'offer-reward-issues': {
    en: 'Offer & Reward Issues',
    hi: 'ऑफ़र और रिवॉर्ड समस्याएं',
    mr: 'ऑफर आणि बक्षीस समस्या',
    gu: 'ઓફર અને ઇનામ સમસ્યાઓ',
    id: 'Masalah Penawaran & Hadiah'
  },
  'withdrawals': {
    en: 'Withdrawals',
    hi: 'निकासी',
    mr: 'पैसे काढणे',
    gu: 'ઉપાડ',
    id: 'Penarikan'
  },
  'account-security': {
    en: 'Account & Security',
    hi: 'खाता और सुरक्षा',
    mr: 'खाते आणि सुरक्षा',
    gu: 'એકાઉન્ટ અને સુરક્ષા',
    id: 'Akun & Keamanan'
  },
  'referrals': {
    en: 'Referrals',
    hi: 'रेफरल',
    mr: 'रेफरल',
    gu: 'રેફરલ',
    id: 'Referral'
  }
};

// FAQ data with multi-language support
export const SIKKA_FAQS = [
  // Offer & Reward Issues Section
  {
    key: 'offer-fail-reason',
    sectionKey: 'offer-reward-issues',
    en: {
      title: 'Why did my offer fail even after completing it?',
      desc: 'Offers are verified by advertisers. Your reward may fail if the app was previously installed, a VPN was used, required steps were incomplete, or the task was not completed within the time limit. Verification can take up to 72 hours.'
    },
    hi: {
      title: 'मेरा ऑफ़र पूरा करने के बाद भी असफल क्यों हो गया?',
      desc: 'ऑफ़र की पुष्टि विज्ञापनदाता द्वारा की जाती है। यदि ऐप पहले से इंस्टॉल था, VPN का उपयोग किया गया, आवश्यक चरण पूरे नहीं किए गए, या समय सीमा के भीतर कार्य पूरा नहीं हुआ, तो इनाम असफल हो सकता है। सत्यापन में 72 घंटे तक लग सकते हैं।'
    },
    mr: {
      title: 'ऑफर पूर्ण केल्यानंतरही ती अपयशी का झाली?',
      desc: 'ऑफर्सची पडताळणी जाहिरातदारांकडून केली जाते. जर अॅप आधीच इंस्टॉल केलेले असेल, VPN वापरला असेल, आवश्यक टप्पे पूर्ण केले नसतील किंवा वेळेच्या मर्यादेत कार्य पूर्ण केले नसेल तर बक्षीस नाकारले जाऊ शकते. पडताळणीसाठी 72 तास लागू शकतात.'
    },
    gu: {
      title: 'મેં ઓફર પૂર્ણ કરી હોવા છતાં તે નિષ્ફળ કેમ થઈ?',
      desc: 'ઓફરોની ચકાસણી જાહેરાતકર્તાઓ દ્વારા કરવામાં આવે છે. જો એપ પહેલેથી ઇન્સ્ટોલ થયેલી હોય, VPN નો ઉપયોગ થયો હોય, જરૂરી પગલાં પૂર્ણ ન કર્યા હોય અથવા સમયમર્યાદામાં કાર્ય પૂર્ણ ન થયું હોય તો ઇનામ નકારી શકાય છે. ચકાસણી માટે 72 કલાક સુધી લાગી શકે છે.'
    },
    id: {
      title: 'Mengapa penawaran saya gagal meskipun sudah diselesaikan?',
      desc: 'Penawaran diverifikasi oleh pengiklan. Hadiah dapat gagal jika aplikasi sudah pernah diinstal sebelumnya, menggunakan VPN, langkah tidak lengkap, atau tidak diselesaikan dalam batas waktu. Verifikasi dapat memakan waktu hingga 72 jam.'
    }
  },
  {
    key: 'offer-reward-not-received',
    sectionKey: 'offer-reward-issues',
    en: {
      title: 'I completed the offer but didn\'t receive my reward. What should I do?',
      desc: 'Please wait up to 72 hours for verification. If the reward is still not credited after that, contact support with the offer name, screenshot of completion, and date & time of completion.'
    },
    hi: {
      title: 'मैंने ऑफ़र पूरा किया लेकिन इनाम नहीं मिला। मुझे क्या करना चाहिए?',
      desc: 'कृपया सत्यापन के लिए 72 घंटे तक प्रतीक्षा करें। यदि उसके बाद भी इनाम जमा नहीं होता है, तो ऑफ़र का नाम, पूर्णता का स्क्रीनशॉट और तारीख व समय के साथ सपोर्ट से संपर्क करें।'
    },
    mr: {
      title: 'मी ऑफर पूर्ण केली पण बक्षीस मिळाले नाही. काय करावे?',
      desc: 'कृपया पडताळणीसाठी 72 तास प्रतीक्षा करा. त्यानंतरही बक्षीस जमा झाले नाही तर ऑफरचे नाव, पूर्णतेचा स्क्रीनशॉट आणि पूर्ण केल्याची तारीख व वेळ यासह सपोर्टशी संपर्क साधा.'
    },
    gu: {
      title: 'મેં ઓફર પૂર્ણ કરી પરંતુ ઇનામ મળ્યું નથી. હવે શું કરવું?',
      desc: 'કૃપા કરીને 72 કલાક સુધી ચકાસણી માટે રાહ જુઓ. ત્યારબાદ પણ ઇનામ જમા ન થાય તો ઓફરનું નામ, પૂર્ણતાનો સ્ક્રીનશોટ અને પૂર્ણ કરવાની તારીખ તથા સમય સાથે સપોર્ટનો સંપર્ક કરો.'
    },
    id: {
      title: 'Saya sudah menyelesaikan penawaran tetapi belum menerima hadiah. Apa yang harus saya lakukan?',
      desc: 'Harap tunggu hingga 72 jam untuk verifikasi. Jika hadiah masih belum dikreditkan, hubungi dukungan dengan nama penawaran, tangkapan layar penyelesaian, serta tanggal dan waktu penyelesaian.'
    }
  },
  {
    key: 'offer-retry',
    sectionKey: 'offer-reward-issues',
    en: {
      title: 'Can I retry an expired offer?',
      desc: 'No. Once an offer expires, it cannot be attempted again on the same device.'
    },
    hi: {
      title: 'क्या मैं एक्सपायर हो चुके ऑफर को फिर से ट्राई कर सकता हूँ?',
      desc: 'नहीं। एक बार ऑफर एक्सपायर हो जाने के बाद, उसी डिवाइस पर उसे दोबारा ट्राई नहीं किया जा सकता।'
    },
    mr: {
      title: 'एक्सपायर झालेला ऑफर पुन्हा ट्राय करू शकतो का?',
      desc: 'नाही. एकदा ऑफर एक्सपायर झाल्यावर, त्याच डिव्हाइसवर तो पुन्हा ट्राय करता येत नाही.'
    },
    gu: {
      title: 'શું હું એક્સપાયર થયેલ ઓફર ફરી પ્રયાસ કરી શકું?',
      desc: 'નહીં. એકવાર ઓફર એક્સપાયર થઈ જાય પછી, તે જ ડિવાઇસ પર તેને ફરી પ્રયાસ કરી શકાય નહીં.'
    },
    id: {
      title: 'Bisakah saya mencoba kembali penawaran yang sudah kedaluwarsa?',
      desc: 'Tidak. Setelah sebuah penawaran kedaluwarsa, penawaran tersebut tidak dapat dicoba kembali di perangkat yang sama.'
    }
  },
  {
    key: 'vpn-usage',
    sectionKey: 'offer-reward-issues',
    en: {
      title: 'Can I use a VPN while completing offers?',
      desc: 'No. Using a VPN may cause tracking failure and reward rejection.'
    },
    hi: {
      title: 'क्या मैं ऑफ़र पूरा करते समय VPN का उपयोग कर सकता हूँ?',
      desc: 'नहीं। VPN का उपयोग ट्रैकिंग विफलता और इनाम अस्वीकृति का कारण बन सकता है।'
    },
    mr: {
      title: 'ऑफर पूर्ण करताना VPN वापरू शकतो का?',
      desc: 'नाही. VPN वापरल्यास ट्रॅकिंग अयशस्वी होऊ शकते आणि बक्षीस नाकारले जाऊ शकते.'
    },
    gu: {
      title: 'ઓફર પૂર્ણ કરતી વખતે VPN નો ઉપયોગ કરી શકું?',
      desc: 'નહીં. VPN નો ઉપયોગ ટ્રેકિંગ નિષ્ફળતા અને ઇનામ નકારવામાં કારણ બની શકે છે.'
    },
    id: {
      title: 'Bisakah saya menggunakan VPN saat menyelesaikan penawaran?',
      desc: 'Tidak. Penggunaan VPN dapat menyebabkan kegagalan pelacakan dan penolakan hadiah.'
    }
  },

  // Withdrawals Section
  {
    key: 'minimum-withdrawal',
    sectionKey: 'withdrawals',
    en: {
      title: 'What is the minimum withdrawal amount?',
      desc: 'Please check the Wallet section in the app for the latest minimum requirement.'
    },
    hi: {
      title: 'न्यूनतम निकासी राशि क्या है?',
      desc: 'नवीनतम न्यूनतम आवश्यकता के लिए ऐप के वॉलेट सेक्शन में देखें।'
    },
    mr: {
      title: 'किमान पैसे काढण्याची रक्कम किती आहे?',
      desc: 'अद्ययावत किमान मर्यादेसाठी अॅपमधील वॉलेट विभाग तपासा.'
    },
    gu: {
      title: 'ઓછામાં ઓછો ઉપાડ કેટલો છે?',
      desc: 'તાજી ન્યૂનતમ જરૂરિયાત માટે એપના વૉલેટ વિભાગ તપાસો.'
    },
    id: {
      title: 'Berapa jumlah minimum penarikan?',
      desc: 'Silakan periksa bagian Dompet di aplikasi untuk persyaratan minimum terbaru.'
    }
  },
  {
    key: 'withdrawal-time',
    sectionKey: 'withdrawals',
    en: {
      title: 'How long does withdrawal take?',
      desc: 'Most withdrawals are processed within minutes. In rare cases it may take up to 24 hours.'
    },
    hi: {
      title: 'निकासी में कितना समय लगता है?',
      desc: 'अधिकांश निकासी कुछ ही मिनटों में संसाधित हो जाती हैं। दुर्लभ मामलों में 24 घंटे तक लग सकते हैं।'
    },
    mr: {
      title: 'पैसे काढण्यासाठी किती वेळ लागतो?',
      desc: 'बहुतांश व्यवहार काही मिनिटांत पूर्ण होतात. क्वचित प्रसंगी 24 तास लागू शकतात.'
    },
    gu: {
      title: 'ઉપાડમાં કેટલો સમય લાગે છે?',
      desc: 'મોટા ભાગના ઉપાડ થોડા મિનિટોમાં પ્રક્રિયા થાય છે. ક્યારેક 24 કલાક સુધી લાગી શકે છે.'
    },
    id: {
      title: 'Berapa lama proses penarikan?',
      desc: 'Sebagian besar penarikan diproses dalam beberapa menit. Dalam kasus tertentu dapat memakan waktu hingga 24 jam.'
    }
  },
  {
    key: 'withdrawal-pending',
    sectionKey: 'withdrawals',
    en: {
      title: 'Why is my withdrawal pending?',
      desc: 'Withdrawals may take longer due to verification checks, incorrect payment details, high withdrawal volume, or security reviews for suspicious activity.'
    },
    hi: {
      title: 'मेरी निकासी लंबित क्यों है?',
      desc: 'सत्यापन जांच, गलत भुगतान विवरण, अधिक निकासी अनुरोध, या संदिग्ध गतिविधि की सुरक्षा समीक्षा के कारण निकासी में अधिक समय लग सकता है।'
    },
    mr: {
      title: 'माझा विथड्रॉवल प्रलंबित का आहे?',
      desc: 'तपासणी प्रक्रिया, चुकीची पेमेंट माहिती, मोठ्या प्रमाणात विथड्रॉअल विनंत्या किंवा संशयास्पद क्रियाकलापांच्या सुरक्षा पुनरावलोकनामुळे विथड्रॉअलला अधिक वेळ लागू शकतो.'
    },
    gu: {
      title: 'મારો ઉપાડ પેન્ડિંગ કેમ છે?',
      desc: 'ચકાસણી પ્રક્રિયા, ખોટી ચુકવણી વિગતો, વધુ વિથડ્રૉલ વિનંતીઓ અથવા શંકાસ્પદ પ્રવૃત્તિની સુરક્ષા સમીક્ષા કારણે વિથડ્રૉલમાં વધુ સમય લાગી શકે છે.'
    },
    id: {
      title: 'Mengapa penarikan saya tertunda?',
      desc: 'Penarikan mungkin memerlukan waktu lebih lama karena proses verifikasi, detail pembayaran yang salah, volume penarikan yang tinggi, atau peninjauan keamanan terhadap aktivitas mencurigakan.'
    }
  },
  {
    key: 'withdrawal-rejected',
    sectionKey: 'withdrawals',
    en: {
      title: 'Why was my withdrawal rejected?',
      desc: 'Common reasons include incorrect payout details, name mismatch, policy violations, or multiple accounts detected.'
    },
    hi: {
      title: 'मेरी निकासी अस्वीकृत क्यों हुई?',
      desc: 'सामान्य कारणों में गलत भुगतान विवरण, नाम का मेल न होना, नीति का उल्लंघन, या एक से अधिक खाते पाए जाना शामिल हैं।'
    },
    mr: {
      title: 'माझा विथड्रॉवल नाकारला का गेला?',
      desc: 'सामान्य कारणांमध्ये चुकीची पेमेंट माहिती, नाव जुळत नसणे, धोरणांचे उल्लंघन किंवा एकापेक्षा जास्त खाती आढळणे यांचा समावेश होतो.'
    },
    gu: {
      title: 'મારો ઉપાડ નકારવામાં કેમ આવ્યો?',
      desc: 'સામાન્ય કારણોમાં ખોટી ચુકવણી વિગતો, નામમાં મેળ ન હોવો, નીતિનું ઉલ્લંઘન, અથવા એકથી વધુ એકાઉન્ટ મળવું સામેલ છે.'
    },
    id: {
      title: 'Mengapa penarikan saya ditolak?',
      desc: 'Alasan umum termasuk detail pembayaran yang salah, ketidaksesuaian nama, pelanggaran kebijakan, atau terdeteksinya beberapa akun.'
    }
  },

  // Account & Security Section
  {
    key: 'account-suspended',
    sectionKey: 'account-security',
    en: {
      title: 'Why was my account suspended?',
      desc: 'Accounts may be restricted for using multiple accounts, VPN/emulator usage, fake referrals, or suspicious activity.'
    },
    hi: {
      title: 'मेरा खाता निलंबित क्यों किया गया?',
      desc: 'कई खाते उपयोग करना, VPN/इम्युलेटर उपयोग, नकली रेफरल या संदिग्ध गतिविधि के कारण खाता प्रतिबंधित किया जा सकता है।'
    },
    mr: {
      title: 'माझे खाते निलंबित का केले गेले?',
      desc: 'अनेक खाती वापरणे, VPN/एम्युलेटर वापर, बनावट रेफरल किंवा संशयास्पद क्रियाकलापांसाठी खाती प्रतिबंधित केली जाऊ शकतात.'
    },
    gu: {
      title: 'મારું એકાઉન્ટ સસ્પેન્ડ કેમ થયું?',
      desc: 'એકથી વધુ એકાઉન્ટનો ઉપયોગ, VPN/એમ્યુલેટર, નકલી રેફરલ અથવા શંકાસ્પદ પ્રવૃત્તિ માટે એકાઉન્ટ પર પ્રતિબંધ મૂકાઈ શકે છે.'
    },
    id: {
      title: 'Mengapa akun saya ditangguhkan?',
      desc: 'Akun dapat dibatasi karena penggunaan beberapa akun, VPN/emulator, referral palsu, atau aktivitas mencurigakan.'
    }
  },
  {
    key: 'multiple-accounts',
    sectionKey: 'account-security',
    en: {
      title: 'Can I create multiple accounts?',
      desc: 'No. Only one account per user/device is allowed. Multiple accounts may lead to suspension.'
    },
    hi: {
      title: 'क्या मैं कई खाते बना सकता हूँ?',
      desc: 'नहीं। प्रति उपयोगकर्ता/डिवाइस केवल एक खाता अनुमत है। कई खाते निलंबन का कारण बन सकते हैं।'
    },
    mr: {
      title: 'मी अनेक खाती तयार करू शकतो का?',
      desc: 'नाही. प्रत्येक वापरकर्ता/डिव्हाइससाठी फक्त एकच खाते परवानगी आहे. अनेक खाती आढळल्यास निलंबन होऊ शकते.'
    },
    gu: {
      title: 'શું હું અનેક એકાઉન્ટ બનાવી શકું?',
      desc: 'નહીં. દરેક યુઝર/ડિવાઇસ માટે માત્ર એક જ એકાઉન્ટ માન્ય છે. અનેક એકાઉન્ટ હોવા પર સસ્પેન્શન થઈ શકે છે.'
    },
    id: {
      title: 'Bisakah saya membuat beberapa akun?',
      desc: 'Tidak. Hanya satu akun per pengguna/perangkat yang diperbolehkan. Beberapa akun dapat menyebabkan penangguhan.'
    }
  },

  // Referrals Section
  {
    key: 'referral-reward-not-received',
    sectionKey: 'referrals',
    en: {
      title: 'Why didn\'t I receive my referral reward?',
      desc: 'Referral rewards are credited only after your friend signs up using your code and completes the required tasks. Rewards may take up to 24 hours after task completion.'
    },
    hi: {
      title: 'मुझे रेफरल इनाम क्यों नहीं मिला?',
      desc: 'रेफरल इनाम तभी जमा होता है जब आपका मित्र आपके कोड से साइन अप करे और आवश्यक कार्य पूरे करे। कार्य पूर्ण होने के बाद 24 घंटे तक लग सकते हैं।'
    },
    mr: {
      title: 'मला रेफरल बक्षीस का मिळाले नाही?',
      desc: 'रेफरल बक्षीस तेव्हाच जमा होते जेव्हा तुमचा मित्र तुमच्या कोडने साइन अप करतो आणि आवश्यक कार्य पूर्ण करतो. कार्य पूर्ण झाल्यानंतर 24 तास लागू शकतात.'
    },
    gu: {
      title: 'મને રેફરલ ઇનામ કેમ મળ્યું નથી?',
      desc: 'રેફરલ ઇનામ ત્યારે જ જમા થાય છે જ્યારે તમારો મિત્ર તમારા કોડનો ઉપયોગ કરીને સાઇન અપ કરે છે અને જરૂરી કાર્ય પૂર્ણ કરે છે. કાર્ય પૂર્ણ થયા પછી 24 કલાક સુધી લાગી શકે છે.'
    },
    id: {
      title: 'Mengapa saya tidak menerima hadiah referral?',
      desc: 'Hadiah referral dikreditkan setelah teman Anda mendaftar menggunakan kode Anda dan menyelesaikan tugas yang diperlukan. Proses dapat memakan waktu hingga 24 jam setelah penyelesaian tugas.'
    }
  },
  {
    key: 'self-referral',
    sectionKey: 'referrals',
    en: {
      title: 'Can I refer myself?',
      desc: 'No. Self-referrals will result in account suspension.'
    },
    hi: {
      title: 'क्या मैं खुद को रेफर कर सकता हूँ?',
      desc: 'नहीं। स्वयं-रेफरल से खाता निलंबित हो सकता है।'
    },
    mr: {
      title: 'मी स्वतःला रेफर करू शकतो का?',
      desc: 'नाही. स्वतःला रेफर केल्यास खाते निलंबित केले जाईल.'
    },
    gu: {
      title: 'શું હું પોતાને રેફર કરી શકું?',
      desc: 'નહીં. સ્વ-રેફરલ કરવાથી એકાઉન્ટ સસ્પેન્ડ થઈ શકે છે.'
    },
    id: {
      title: 'Bisakah saya mereferensikan diri sendiri?',
      desc: 'Tidak. Self-referral dapat menyebabkan akun ditangguhkan.'
    }
  }
];
